import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=5ae4ad68"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"
import style0 from "./manage.vue?vue&type=style&index=0&id=5ae4ad68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports